import React from 'react';
import Select from '@blaze-react/select';
import { useRouter } from 'next/router';
import { parseUrl } from 'query-string';
import PropTypes from 'prop-types';
import { DEFAULT_SORT } from './constants';
import { handleSortUpdate } from './helpers';
import { withTitle } from '../../HOC';
const getSortFromQuery = listComponentName => {
  const listNameKey = listComponentName ? `pb[${listComponentName}]` : '';
  const sortKey = `${listNameKey}${listNameKey ? '[sort]' : 'sort'}`;
  const sortByKey = `${listNameKey}${listNameKey ? '[sortby]' : 'sortby'}`;
  return [sortKey, sortByKey];
};
const SearchFilterSort = ({
  filters,
  elementLabel,
  selectLabel,
  id,
  listComponentName
}) => {
  const router = useRouter();
  const {
    asPath
  } = router;
  const [sortKey, sortByKey] = getSortFromQuery(listComponentName);
  const {
    url,
    query,
    query: {
      [sortKey]: sort,
      [sortByKey]: sortby
    } = {}
  } = parseUrl(asPath);
  const selectedValue = `${sortby}:${sort}` || '';
  const defaultTextValue = selectLabel || DEFAULT_SORT;
  const options = filters.map(({
    label: optionLabel,
    propsToDisplay,
    sort: sortValue
  }) => [`${propsToDisplay[0]}:${sortValue}`, optionLabel]);
  const setSortValue = ({
    value
  }) => handleSortUpdate({
    router,
    value,
    query,
    url,
    selectLabel,
    listComponentName
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "sort-by"
  }, /*#__PURE__*/React.createElement(Select, {
    name: "sortby",
    label: elementLabel,
    defaultTextValue: defaultTextValue,
    value: selectedValue,
    id: id,
    options: options,
    onChange: setSortValue
  }));
};
SearchFilterSort.propTypes = {
  filters: PropTypes.array,
  elementLabel: PropTypes.string,
  selectLabel: PropTypes.string,
  id: PropTypes.string,
  listComponentName: PropTypes.string
};
SearchFilterSort.defaultProps = {
  filters: [],
  elementLabel: '',
  selectLabel: '',
  id: '',
  listComponentName: ''
};
export default withTitle(SearchFilterSort);
//# sourceMappingURL=SearchFilterSort.js.map